/**
 * VP-322: jedno źródło prawdy o pakietach dodatkowych kont reklamowych — wspólne dla
 * frontu (kafelki w panelu rozliczeń) i backendu (walidacja `priceId` przy checkoucie
 * i mapowanie webhooka Stripe na `users.ad_account_pack_size`).
 *
 * Wcześniej katalog istniał w dwóch kopiach: `AD_ACCOUNT_PACKS` w `billing-panel.tsx`
 * i `AD_ACCOUNT_PACK_PRICES` w `stripe-service.ts`. Rozjazd między nimi (np. nowy pakiet
 * dodany tylko po stronie backendu) po cichu wyłączał plakietkę „Aktywny" w UI — bo
 * zapisany `adAccountPackSize` nie pasował do żadnego kafelka — i nie dawał ani błędu
 * kompilacji, ani czerwonego testu.
 *
 * `price` to kwota prezentowana w UI (PLN/mc). Faktyczną kwotę obciążenia ustala Stripe
 * po stronie `priceId` — ta wartość jest wyłącznie do wyświetlenia w cenniku.
 */

export type AdAccountPack = {
  /** Stripe Price ID (subskrypcja miesięczna dodatku). */
  priceId: string;
  /** Ile kont reklamowych ponad limit planu daje pakiet. */
  accounts: number;
  /** Cena prezentowana w UI (PLN/mc). */
  price: number;
};

export const AD_ACCOUNT_PACKS: readonly AdAccountPack[] = [
  { priceId: "price_1THMstRxO0w5bTlQWxUhCGY6", accounts: 5, price: 79 },
  { priceId: "price_1TJFqNRxO0w5bTlQGWmG53tc", accounts: 15, price: 179 },
  { priceId: "price_1TJFquRxO0w5bTlQ5bJMv4yx", accounts: 50, price: 399 },
  { priceId: "price_1TJFrDRxO0w5bTlQTnHHRi2a", accounts: 250, price: 999 },
];

/** Stripe Price ID → liczba dodatkowych kont. Wyprowadzone z katalogu, nie duplikuj. */
export const AD_ACCOUNT_PACK_SIZE_BY_PRICE_ID: Record<string, number> = Object.fromEntries(
  AD_ACCOUNT_PACKS.map((pack) => [pack.priceId, pack.accounts])
);

/** `undefined` = `priceId` nie jest pakietem kont reklamowych (odrzuć żądanie). */
export function resolveAdAccountPackSize(priceId: unknown): number | undefined {
  return typeof priceId === "string" ? AD_ACCOUNT_PACK_SIZE_BY_PRICE_ID[priceId] : undefined;
}

/** Czy `priceId` należy do katalogu pakietów kont reklamowych. */
export function isAdAccountPackPriceId(priceId: string): boolean {
  return priceId in AD_ACCOUNT_PACK_SIZE_BY_PRICE_ID;
}
